import React from 'react';
import './ToolbarInfo.less'
const ToolbarInfo = ({title,style,additionalCounter}) => {
    return (
        <div className={'toolbar_info'} style={style ?? {}}>
            {title}
            {additionalCounter!=undefined && <span className={'additional_counter'}> — {additionalCounter}</span>}
        </div>
    );
};

export default ToolbarInfo;

const styledAdditionalCounter={
    top:70,
    fontSize: '16px',
    position: 'relative'
}